var Top = {
  neco: "text1",
  razitko: "1.0.0", //razitko pro brazky atd
  jeIframe: false,
  idStrany: false,
  zobrazWidget: false,
  jazyk: "cs",
  zobrazitKonfiguratorZbrane: true, //lze vypnout kompletne na strankach
  Uzivatel: {
    prihlasen: null,
    overeniPrihlaseni: function() {
      let C = window.getShoptetDataLayer("customer");
      return C.mainAccount ? true : false;
    },

    jePrihlasen: function() {
      return Top.Uzivatel.prihlasen;
    }
  },

  _init: function() {
    Lc.h("Top.init");
    let $stav = Top.Uzivatel.overeniPrihlaseni();
    Top.Uzivatel.prihlasen = $stav;
    let lng = window.getShoptetDataLayer("language") || "cs";
    Top.jazyk = lng;
  }
};

Top._init();

export { Top };
